import { useState, type ReactNode } from 'react'

// Versão enxuta do painel de Tweaks do protótipo (ferramenta de exploração de design).
// No standalone (sem host), um botão flutuante (⚙) abre/fecha o painel.
export function useTweaks<T extends Record<string, unknown>>(defaults: T): [T, (k: keyof T, v: unknown) => void] {
  const [values, setValues] = useState<T>(defaults)
  const setTweak = (k: keyof T, v: unknown) => setValues((prev) => ({ ...prev, [k]: v }))
  return [values, setTweak]
}

export function TweaksPanel({ title = 'Tweaks', children }: { title?: string; children: ReactNode }) {
  const [open, setOpen] = useState(false)
  return (
    <>
      <button className="twk-fab" title="Tweaks de design" aria-label="Abrir tweaks" onClick={() => setOpen((o) => !o)}>⚙</button>
      {open && (
        <div className="twk-panel">
          <div className="twk-hd"><b>{title}</b><button className="twk-x" onClick={() => setOpen(false)}>✕</button></div>
          <div className="twk-body">{children}</div>
        </div>
      )}
    </>
  )
}

export function TweakSection({ label }: { label: string }) {
  return <div className="twk-sect">{label}</div>
}

type Opt = string | { value: string; label: string }
export function TweakRadio({ label, value, options, onChange }: {
  label: string; value: string; options: Opt[]; onChange: (v: string) => void
}) {
  const opts = options.map((o) => (typeof o === 'object' ? o : { value: o, label: o }))
  return (
    <div className="twk-row">
      <div className="twk-lbl"><span>{label}</span></div>
      <div className="twk-seg">
        {opts.map((o) => (
          <button key={o.value} className={value === o.value ? 'is-active' : ''} onClick={() => onChange(o.value)}>{o.label}</button>
        ))}
      </div>
    </div>
  )
}
